var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompanyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#1B49EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.125C13.8271 8.125 12.0625 9.88956 12.0625 12.0625C12.0625 14.2354 13.8271 16 16 16C18.1729 16 19.9375 14.2354 19.9375 12.0625C19.9375 9.88956 18.1729 8.125 16 8.125ZM16 9.25C17.5525 9.25 18.8125 10.51 18.8125 12.0625C18.8125 13.615 17.5525 14.875 16 14.875C14.4475 14.875 13.1875 13.615 13.1875 12.0625C13.1875 10.51 14.4475 9.25 16 9.25Z",
    fill: "#1B49EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 22.75H16C16.3105 22.75 16.5625 23.002 16.5625 23.3125C16.5625 23.623 16.3105 23.875 16 23.875H8.6875C8.377 23.875 8.125 23.623 8.125 23.3125C8.125 23.3125 8.125 22.8484 8.125 22.1875C8.125 19.3913 10.3913 17.125 13.1875 17.125H16C16.3105 17.125 16.5625 17.377 16.5625 17.6875C16.5625 17.998 16.3105 18.25 16 18.25H13.1875C11.0129 18.25 9.25 20.0129 9.25 22.1875V22.75Z",
    fill: "#1B49EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7807 17.125C18.763 17.125 17.125 18.763 17.125 20.7807C17.125 22.7984 18.763 24.4364 20.7807 24.4364C22.7984 24.4364 24.4364 22.7984 24.4364 20.7807C24.4364 18.763 22.7984 17.125 20.7807 17.125ZM20.7807 18.25C22.1774 18.25 23.3114 19.384 23.3114 20.7807C23.3114 22.1774 22.1774 23.3114 20.7807 23.3114C19.384 23.3114 18.25 22.1774 18.25 20.7807C18.25 19.384 19.384 18.25 20.7807 18.25Z",
    fill: "#1B49EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5472 20.8172L21.7842 19.5454C22.0007 19.3227 22.3574 19.3176 22.5795 19.5342C22.8023 19.7507 22.8074 20.1068 22.5908 20.3295L20.9505 22.0159C20.8448 22.125 20.6991 22.1864 20.5472 22.1864C20.3954 22.1864 20.2502 22.125 20.1439 22.0159L18.9717 20.8105C18.7551 20.5877 18.7602 20.2317 18.9829 20.0151C19.2057 19.7985 19.5617 19.8036 19.7783 20.0264L20.5472 20.8172Z",
    fill: "#1B49EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyWhite);
export default __webpack_public_path__ + "static/media/companyWhite.b0e1f38659571c9cd3e21c1f5d3a0b6b.svg";
export { ForwardRef as ReactComponent };